import * as React from "react";
import { useMemo } from "react";
import { Badge } from "common/components";
const badgeColorByPriority = (p, threshold) => {
  if (p >= threshold) return "danger";
  if (p === threshold - 1) return "warning";
  return "default";
};
const PriorityCell = ({ priorityValue = null, priorities, showFallback = false }) => {
  const [critical, high] = useMemo(() => {
    var _a;
    if (!priorities || priorities.length === 0) {
      return [void 0, void 0];
    }
    const lastIndex = priorities.length - 1;
    return [priorities[lastIndex], (_a = priorities[lastIndex - 1]) != null ? _a : priorities[lastIndex]];
  }, [priorities]);
  const priorityText = useMemo(
    () => {
      var _a;
      return ((_a = priorities == null ? void 0 : priorities.find((priority) => priority.priority === priorityValue)) == null ? void 0 : _a.text) || null;
    },
    [priorities, priorityValue]
  );
  if (priorityValue === null || priorityValue === void 0 || priorityValue === 0) {
    return showFallback ? /* @__PURE__ */ React.createElement("i", null, "No Priority") : null;
  }
  const variant = (high == null ? void 0 : high.priority) ? badgeColorByPriority(priorityValue, high.priority) : "default";
  const solid = (critical == null ? void 0 : critical.priority) ? priorityValue === critical.priority : false;
  return /* @__PURE__ */ React.createElement(Badge, { size: "sm", variant, solid }, priorityText != null ? priorityText : priorityValue);
};
export default PriorityCell;
